
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("bRPo1", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e569016d63746a22$var$baseStyles = null;
const $e569016d63746a22$var$justifyStartStyles = null;
const $e569016d63746a22$var$justifyEndStyles = null; /**
                                * __Tag group__
                                *
                                * A tag group controls the layout and alignment for a collection of tags.
                                *
                                * - [Examples](https://atlassian.design/components/tag-group/examples)
                                * - [Code](https://atlassian.design/components/tag-group/code)
                                * - [Usage](https://atlassian.design/components/tag-group/usage)
                                */ 
const $e569016d63746a22$var$TagGroup = /*#__PURE__*/ (0, $42omo.forwardRef)(({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bsb1osq _1n261g80",
            alignment === 'start' && "_1bah1y6m",
            alignment === 'end' && "_1bahesu3"
        ]),
        children: children
    });
});
var $e569016d63746a22$export$2e2bcd8739ae039 = $e569016d63746a22$var$TagGroup;
module.exports["default"] = $e569016d63746a22$export$2e2bcd8739ae039;

});

parcelRegister("lBvGi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $56c2dc0faf44f7eb$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $c0qxy = parcelRequire("c0qxy");


var $kZ5GD = parcelRequire("kZ5GD");

const $56c2dc0faf44f7eb$var$noOptions = [];
function $56c2dc0faf44f7eb$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $56c2dc0faf44f7eb$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, labelId: labelId, onInvalid: onInvalid = (0, $ee7An.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $c0qxy.useId)();
    const [selectedValue, setSelectedValue] = (0, $42omo.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "radiogroup",
        // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
        "aria-labelledby": labelId || ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $42omo.createElement)((0, $kZ5GD.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});

parcelRegister("h17uI", function(module, exports) {
/*!
 * is-number <https://github.com/jonschlinkert/is-number>
 *
 * Copyright (c) 2014-present, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
module.exports = function(num) {
    if (typeof num === 'number') return num - num === 0;
    if (typeof num === 'string' && num.trim() !== '') return Number.isFinite ? Number.isFinite(+num) : isFinite(+num);
    return false;
};

});

parcelRegister("1RqgI", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $iZTFQ = parcelRequire("iZTFQ");


var $gEpEw = parcelRequire("gEpEw");

class $f76d2aa2a1b6bce3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gEpEw.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        };
        this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        };
        this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        };
        this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        };
        this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $iZTFQ.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}
$f76d2aa2a1b6bce3$export$2e2bcd8739ae039.defaultProps = {
    defaultPage: 1,
    isLoading: false,
    isFixedSize: false,
    isRankable: false,
    onSetPage: (0, $ee7An.default),
    onSort: (0, $ee7An.default),
    rowsPerPage: Infinity
};
module.exports["default"] = $f76d2aa2a1b6bce3$export$2e2bcd8739ae039;

});

parcelRegister("iZTFQ", function(module, exports) {
const $7136cb869e4237cd$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $7136cb869e4237cd$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $7136cb869e4237cd$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $7136cb869e4237cd$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $7136cb869e4237cd$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $7136cb869e4237cd$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $7136cb869e4237cd$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $7136cb869e4237cd$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};
module.exports["getPageRows"] = $7136cb869e4237cd$export$3987dc24b734dcab;
module.exports["assertIsSortable"] = $7136cb869e4237cd$export$5eb35a4771ec4090;
module.exports["validateSortKey"] = $7136cb869e4237cd$export$9133f5a8bfe8a200;
module.exports["inlineStylesIfRanking"] = $7136cb869e4237cd$export$a601f1775e10043f;
module.exports["reorderRows"] = $7136cb869e4237cd$export$c476bbe5da59992d;

});

parcelRegister("gEpEw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $acwm0 = parcelRequire("acwm0");


var $iZTFQ = parcelRequire("iZTFQ");


var $a1aS7 = parcelRequire("a1aS7");


var $1QeRM = parcelRequire("1QeRM");


var $4S6q0 = parcelRequire("4S6q0");


var $ariie = parcelRequire("ariie");


var $fsOrO = parcelRequire("fsOrO");


var $gR32R = parcelRequire("gR32R");


var $3l42I = parcelRequire("3l42I");


var $lF3zd = parcelRequire("lF3zd");

function $5c24977a9a721875$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $acwm0.DESC:
            return 0, $acwm0.ASC;
        case 0, $acwm0.ASC:
            return 0, $acwm0.DESC;
        default:
            return currentSortOrder;
    }
}
const $5c24977a9a721875$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $ee7An.default), onSort: providedOnSort = (0, $ee7An.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $ee7An.default), onRankEnd: providedOnRankEnd = (0, $ee7An.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $42omo.useState)(false);
    const tableBodyRef = (0, $42omo.useRef)(null);
    const onSort = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $42omo.useEffect)(()=>{
        (0, $iZTFQ.validateSortKey)(sortKey, head);
        (0, $iZTFQ.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $acwm0.DESC)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $acwm0.ASC) : $5c24977a9a721875$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $iZTFQ.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $acwm0.LARGE) : (0, $acwm0.SMALL);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1QeRM.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $l998X.jsx)((0, $1QeRM.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gR32R.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $a1aS7.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $l998X.jsx)((0, $a1aS7.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $l998X.jsx)((0, $lF3zd.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $l998X.jsx)($5c24977a9a721875$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a1aS7.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3l42I.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $l998X.jsx)((0, $fsOrO.default), {
                isLoading: isLoading,
                spinnerSize: (0, $acwm0.LARGE),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $5c24977a9a721875$var$RankableTableBody = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("i3bGv")));
const $5c24977a9a721875$var$TableBody = /*#__PURE__*/ (0, $42omo.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $l998X.jsx)((0, $4S6q0.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ariie.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $l998X.jsx)($5c24977a9a721875$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5c24977a9a721875$export$2e2bcd8739ae039 = $5c24977a9a721875$var$DynamicTable;
module.exports["default"] = $5c24977a9a721875$export$2e2bcd8739ae039;

});

parcelRegister("acwm0", function(module, exports) {
const $0675324f6a750b1a$export$1dee026a19752d6b = 'ASC';
const $0675324f6a750b1a$export$b6abcf7fa1d94f65 = 'DESC';
const $0675324f6a750b1a$export$71dd4c8ecd45e95f = 'small';
const $0675324f6a750b1a$export$7b93a10c0fefe3e3 = 'large';
const $0675324f6a750b1a$export$3843c586a90b9cbf = 0.22;
module.exports["ASC"] = $0675324f6a750b1a$export$1dee026a19752d6b;
module.exports["DESC"] = $0675324f6a750b1a$export$b6abcf7fa1d94f65;
module.exports["SMALL"] = $0675324f6a750b1a$export$71dd4c8ecd45e95f;
module.exports["LARGE"] = $0675324f6a750b1a$export$7b93a10c0fefe3e3;
module.exports["LOADING_CONTENTS_OPACITY"] = $0675324f6a750b1a$export$3843c586a90b9cbf;

});

parcelRegister("a1aS7", function(module, exports) {
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $cd45f3a97f0c2709$var$fixedSizeTableStyles = null;
const $cd45f3a97f0c2709$var$tableStyles = null;
const $cd45f3a97f0c2709$var$bodyBorder = null;
const $cd45f3a97f0c2709$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("table" // React and Typescript do not yet support the inert attribute https://github.com/facebook/react/pull/24730
    , {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CFE1FD)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #4688EC)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _yq5hus1c _btyzidpf _ect4ttxp",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1uh4"
        ]),
        children: children
    });
});
const $cd45f3a97f0c2709$var$captionStyles = null;
const $cd45f3a97f0c2709$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("caption", {
        className: (0, $gMc0m.default)([
            "_11c81af2 _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $cd45f3a97f0c2709$var$paginationWrapperStyles = null;
const $cd45f3a97f0c2709$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });
module.exports["Table"] = $cd45f3a97f0c2709$export$54ec01a60f47d33d;
module.exports["Caption"] = $cd45f3a97f0c2709$export$32fbfacc5d962e0c;
module.exports["PaginationWrapper"] = $cd45f3a97f0c2709$export$3e5e12dc01f20a43;

});

parcelRegister("1QeRM", function(module, exports) {
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $c201fa6e50809e47$var$fixedHeightStyles = null;
const $c201fa6e50809e47$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $gMc0m.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $c201fa6e50809e47$var$emptyViewContainerStyles = null;
const $c201fa6e50809e47$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $gMc0m.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};
module.exports["EmptyViewWithFixedHeight"] = $c201fa6e50809e47$export$8f45b9407d4090d7;
module.exports["EmptyViewContainer"] = $c201fa6e50809e47$export$381ea436de119582;

});

parcelRegister("4S6q0", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6ZeF0 = parcelRequire("6ZeF0");


var $cBjhI = parcelRequire("cBjhI");

// eslint-disable-next-line @repo/internal/react/no-class-components
class $07b7d6d69c936337$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $cBjhI.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $07b7d6d69c936337$var$Body = (0, $6ZeF0.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($07b7d6d69c936337$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$07b7d6d69c936337$export$2e2bcd8739ae039 = $07b7d6d69c936337$var$Body;
module.exports["default"] = $07b7d6d69c936337$export$2e2bcd8739ae039;

});

parcelRegister("6ZeF0", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b3dd488c65554a3$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $acwm0 = parcelRequire("acwm0");


var $iZTFQ = parcelRequire("iZTFQ");

const $9b3dd488c65554a3$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $9b3dd488c65554a3$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $acwm0.ASC) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $9b3dd488c65554a3$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $9b3dd488c65554a3$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $9b3dd488c65554a3$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $iZTFQ.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $9b3dd488c65554a3$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $iZTFQ.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $l998X.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("cBjhI", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lLKv4 = parcelRequire("lLKv4");


var $iu1PC = parcelRequire("iu1PC");

const $979466b421ef3326$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iu1PC.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $42omo.createElement)((0, $lLKv4.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$979466b421ef3326$export$2e2bcd8739ae039 = $979466b421ef3326$var$Row;
module.exports["default"] = $979466b421ef3326$export$2e2bcd8739ae039;

});

parcelRegister("lLKv4", function(module, exports) {
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $lo5NK = parcelRequire("lo5NK");

const $14854dc930c609a4$var$fixedSizeTruncateStyles = null;
const $14854dc930c609a4$var$overflowTruncateStyles = null;
const $14854dc930c609a4$var$truncationWidthStyles = null;
const $14854dc930c609a4$var$cellStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $14854dc930c609a4$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)("td" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        style: (0, $lo5NK.getTruncationStyleVars)({
            width: width
        }),
        // @ts-ignore
        ref: innerRef,
        className: (0, $gMc0m.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });
module.exports["TableBodyCell"] = $14854dc930c609a4$export$948e91fcef170792;

});

parcelRegister("lo5NK", function(module, exports) {
const $2d66c0434ecf2ef8$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $2d66c0434ecf2ef8$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$2d66c0434ecf2ef8$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
module.exports["getTruncationStyleVars"] = $2d66c0434ecf2ef8$export$5e6497a652ae30b5;

});

parcelRegister("iu1PC", function(module, exports) {
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $8163b397157d0c91$var$rowStyles = null;
const $8163b397157d0c91$var$rowBackgroundStyles = null;
const $8163b397157d0c91$var$rowHighlightedBackgroundStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $8163b397157d0c91$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("tr" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gMc0m.default)([
            "_bfhksm61 _1ygbdfik _1ah312gs",
            isHighlighted ? "_bfhk15s3 _irr3ufnl" : "_irr31dpa",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});
module.exports["TableBodyRow"] = $8163b397157d0c91$export$45f39d9c38b886d5;

});

parcelRegister("ariie", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $e87925282ef46156$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["ErrorBoundary"] = $e87925282ef46156$export$e926676385687eaf;

});

parcelRegister("fsOrO", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $acwm0 = parcelRequire("acwm0");


var $2qpLu = parcelRequire("2qpLu");

class $d7f23e5c1016680b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2qpLu.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $l998X.jsx)((0, $2qpLu.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $2qpLu.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}
$d7f23e5c1016680b$export$2e2bcd8739ae039.defaultProps = {
    isLoading: true,
    spinnerSize: (0, $acwm0.LARGE),
    contentsOpacity: (0, $acwm0.LOADING_CONTENTS_OPACITY),
    loadingLabel: 'Loading table'
};
module.exports["default"] = $d7f23e5c1016680b$export$2e2bcd8739ae039;

});

parcelRegister("2qpLu", function(module, exports) {
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $0273760afafdefb6$export$c335a80381ec61f5 = '--contents-opacity';
const $0273760afafdefb6$var$containerStyles = null;
const $0273760afafdefb6$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $0273760afafdefb6$var$contentsContainerStyles = null;
const $0273760afafdefb6$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            [$0273760afafdefb6$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $gMc0m.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $0273760afafdefb6$var$spinnerContainerStyles = null;
const $0273760afafdefb6$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $gMc0m.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });
module.exports["Container"] = $0273760afafdefb6$export$42a852a2b6b56249;
module.exports["ContentsContainer"] = $0273760afafdefb6$export$67c29eae8ae2137a;
module.exports["SpinnerContainer"] = $0273760afafdefb6$export$a5e06607a5ac6158;

});

parcelRegister("gR32R", function(module, exports) {
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $acwm0 = parcelRequire("acwm0");


var $eQFTY = parcelRequire("eQFTY");

class $23b1b51bd1ae612c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eQFTY.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $eQFTY.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eQFTY.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        };
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        };
        this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        };
        this.componentWillUnmount = ()=>{
            this.detachListeners();
        };
        this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        };
        this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
        this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        };
        this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        };
        this.handleResize = ()=>{
            this.updateSpinnerPosition();
        };
        this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        };
        this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        };
        this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}
$23b1b51bd1ae612c$export$2e2bcd8739ae039.defaultProps = {
    isLoading: true,
    spinnerSize: (0, $acwm0.LARGE),
    contentsOpacity: `var(--ds-opacity-loading, ${`${0, $acwm0.LOADING_CONTENTS_OPACITY}`})`,
    loadingLabel: 'Loading table'
};
module.exports["default"] = $23b1b51bd1ae612c$export$2e2bcd8739ae039;

});

parcelRegister("eQFTY", function(module, exports) {
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6d5e1b6cb99753a2$var$containerStyles = null;
const $6d5e1b6cb99753a2$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $6d5e1b6cb99753a2$var$spinnerBackdropStyles = null;
const $6d5e1b6cb99753a2$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $gMc0m.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $6d5e1b6cb99753a2$var$spinnerContainerStyles = null;
const $6d5e1b6cb99753a2$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));
module.exports["Container"] = $6d5e1b6cb99753a2$export$42a852a2b6b56249;
module.exports["SpinnerBackdrop"] = $6d5e1b6cb99753a2$export$aa207050321b0c53;
module.exports["SpinnerContainer"] = $6d5e1b6cb99753a2$export$a5e06607a5ac6158;

});

parcelRegister("3l42I", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dsM1s = parcelRequire("dsM1s");

class $5ca997743c0935b2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $dsM1s.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}
module.exports["default"] = $5ca997743c0935b2$export$2e2bcd8739ae039;

});

parcelRegister("dsM1s", function(module, exports) {
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $laHi9 = parcelRequire("laHi9");


var $6R5uz = parcelRequire("6R5uz");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $aNNTx = parcelRequire("aNNTx");


var $hBGRU = parcelRequire("hBGRU");


var $kLrz5 = parcelRequire("kLrz5");


var $dSfjw = parcelRequire("dSfjw");


var $l7NbM = parcelRequire("l7NbM");

const $6fe03321c7228100$var$styles = {
    paginationMenu: "_1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t",
    paginationMenuItem: "_1pfhze3t _ect4ttxp",
    navigatorIconWrapper: "_18zr12x7"
};
const $6fe03321c7228100$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $6fe03321c7228100$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($laHi9))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "span",
        xcss: $6fe03321c7228100$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Chevron, {
            label: "",
            color: "currentColor",
            size: "small"
        })
    });
}
function $6fe03321c7228100$var$InnerPagination({ components: components = (0, $dSfjw.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $dSfjw.emptyObject), max: max = 7, onChange: onChange = (0, $ee7An.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $kLrz5.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $6mkwk.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$6fe03321c7228100$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            as: "li",
            xcss: $6fe03321c7228100$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hBGRU.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $aNNTx.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $l998X.jsx)($6fe03321c7228100$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $6fe03321c7228100$var$styles.paginationMenu,
                    children: (0, $l7NbM.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $aNNTx.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $l998X.jsx)($6fe03321c7228100$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $6fe03321c7228100$var$Pagination = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)($6fe03321c7228100$var$InnerPagination));
var $6fe03321c7228100$export$2e2bcd8739ae039 = $6fe03321c7228100$var$Pagination;
module.exports["default"] = $6fe03321c7228100$export$2e2bcd8739ae039;

});

parcelRegister("aNNTx", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e29809e32dcc0c3$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eEA8O = parcelRequire("eEA8O");

function $4e29809e32dcc0c3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("hBGRU", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cc2659209e25aa4$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eEA8O = parcelRequire("eEA8O");

function $2cc2659209e25aa4$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("kLrz5", function(module, exports) {
$parcel$export(module.exports, "default", () => $327224ec3ee62dd2$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $6F6hl = parcelRequire("6F6hl");

const $327224ec3ee62dd2$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $327224ec3ee62dd2$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "li",
        testId: testId,
        xcss: $327224ec3ee62dd2$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $6F6hl.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("dSfjw", function(module, exports) {
const $ccc55450a2ce3996$export$3f860eba1218f8d3 = {};
module.exports["emptyObject"] = $ccc55450a2ce3996$export$3f860eba1218f8d3;

});

parcelRegister("l7NbM", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $e6d8d358662d744b$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $2XqLN.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $e6d8d358662d744b$export$2e2bcd8739ae039 = $e6d8d358662d744b$var$collapseRange;
module.exports["default"] = $e6d8d358662d744b$export$2e2bcd8739ae039;

});

parcelRegister("lF3zd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $iZTFQ = parcelRequire("iZTFQ");


var $65EM3 = parcelRequire("65EM3");


var $l8KsL = parcelRequire("l8KsL");


var $73K2i = parcelRequire("73K2i");

// eslint-disable-next-line @repo/internal/react/no-class-components
class $28a7f7501af435d6$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    UNSAFE_componentWillMount() {
        (0, $iZTFQ.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $iZTFQ.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $l8KsL.default) : (0, $73K2i.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $65EM3.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $l998X.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $l998X.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$28a7f7501af435d6$export$2e2bcd8739ae039 = $28a7f7501af435d6$var$TableHead;
module.exports["default"] = $28a7f7501af435d6$export$2e2bcd8739ae039;

});

parcelRegister("65EM3", function(module, exports) {
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $acwm0 = parcelRequire("acwm0");


var $lo5NK = parcelRequire("lo5NK");

const $207a1abf337d81f4$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $207a1abf337d81f4$var$rankingStyles = null;
const $207a1abf337d81f4$var$headStyles = null;
const $207a1abf337d81f4$var$overflowTruncateStyles = null;
const $207a1abf337d81f4$var$truncationWidthStyles = null;
const $207a1abf337d81f4$var$fixedSizeTruncateStyles = null;
const $207a1abf337d81f4$var$cellStyles = null;
const $207a1abf337d81f4$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $gMc0m.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $207a1abf337d81f4$var$headCellBaseStyles = null;
const $207a1abf337d81f4$export$4e8024263ace498b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $lo5NK.getTruncationStyleVars)({
            width: width
        }),
        [$207a1abf337d81f4$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
    };
    const isASC = sortOrder === (0, $acwm0.ASC);
    const isDESC = sortOrder === (0, $acwm0.DESC);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    }; // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $gMc0m.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8wadc _179r1uh4 _mqm2glyw _kqswh2mm _syazazsu _k48pwu06 _y3gn1e5h _s7n4nkob _1ygbd0i9",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ]),
        children: children
    });
});
module.exports["Head"] = $207a1abf337d81f4$export$e93312b7773dfcac;
module.exports["HeadCell"] = $207a1abf337d81f4$export$4e8024263ace498b;

});

parcelRegister("l8KsL", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $iwGL6 = parcelRequire("iwGL6");


var $iZTFQ = parcelRequire("iZTFQ");


var $73K2i = parcelRequire("73K2i");

// eslint-disable-next-line @repo/internal/react/no-class-components
class $3c91b6293fefaa96$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $iZTFQ.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $73K2i.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $3c91b6293fefaa96$var$RankableTableHeadCell = (0, $iwGL6.default)($3c91b6293fefaa96$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3c91b6293fefaa96$export$2e2bcd8739ae039 = $3c91b6293fefaa96$var$RankableTableHeadCell;
module.exports["default"] = $3c91b6293fefaa96$export$2e2bcd8739ae039;

});

parcelRegister("iwGL6", function(module, exports) {
$parcel$export(module.exports, "default", () => $12473f443f38c444$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $12473f443f38c444$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.ref = void 0;
            this.state = {
                refWidth: 0,
                refHeight: 0
            };
            this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            };
            this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("73K2i", function(module, exports) {
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $22Iw9 = parcelRequire("22Iw9");


var $euUgw = parcelRequire("euUgw");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");


var $3gadb = parcelRequire("3gadb");


var $acwm0 = parcelRequire("acwm0");


var $65EM3 = parcelRequire("65EM3");

const $b62786d16abca385$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $b62786d16abca385$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c8wadc _syazazsu _k48pwu06"
};
const $b62786d16abca385$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $42omo.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $42omo.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b62786d16abca385$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: sortOrder === (0, $acwm0.ASC) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
                onClick: onClick,
                xcss: $b62786d16abca385$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                        xcss: isVisibleIconOnlyHeader ? $b62786d16abca385$var$styles.hideIconHeaderWrapper : $b62786d16abca385$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                            className: (0, $gMc0m.default)([
                                $b62786d16abca385$var$headCellStyles.text
                            ]),
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                        xcss: isSortIconVisible ? $b62786d16abca385$var$styles.sortIconVisibleWrapper : $b62786d16abca385$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $acwm0.ASC) ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
                            label: "",
                            color: "var(--ds-text-subtle, #505258)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($22Iw9))), {
                            label: "",
                            color: "var(--ds-text-subtle, #505258)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $65EM3.HeadCell // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ), {
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b62786d16abca385$export$2e2bcd8739ae039 = $b62786d16abca385$var$TableHeadCell;
module.exports["default"] = $b62786d16abca385$export$2e2bcd8739ae039;

});

parcelRegister("i3bGv", function(module, exports) {

let $d2419224dbf0c85e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d2419224dbf0c85e$var$load("lUQAm"),
    $d2419224dbf0c85e$var$load("8makw"),
    $d2419224dbf0c85e$var$load("heWL2")
]).then(()=>parcelRequire('dHxkf'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("bIBXx", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dWCFT = parcelRequire("dWCFT");

var $cFEpk = parcelRequire("cFEpk");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $5TGLQ = parcelRequire("5TGLQ");


var $99qsA = parcelRequire("99qsA");

var $6T8v4 = parcelRequire("6T8v4");

var $eKXGE = parcelRequire("eKXGE");


var $2oOe7 = parcelRequire("2oOe7");


var $jgNUL = parcelRequire("jgNUL");


var $6BP5H = parcelRequire("6BP5H");


var $7lMCw = parcelRequire("7lMCw");


var $cda8t = parcelRequire("cda8t");

const $6a13142a7a4ddecd$var$packageName = "platform-pkg";
const $6a13142a7a4ddecd$var$packageVersion = "0.0.0-use.local";
const $6a13142a7a4ddecd$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $6a13142a7a4ddecd$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $6a13142a7a4ddecd$var$packageName,
    packageVersion: $6a13142a7a4ddecd$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $6a13142a7a4ddecd$var$TimePicker = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $ee7An.default), onChange: providedOnChange = (0, $ee7An.default), onFocus: providedOnFocus = (0, $ee7An.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $6BP5H.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $2oOe7.defaultTimes), value: providedValue }, _ref)=>{
    const [containerRef, setContainerRef] = (0, $42omo.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $42omo.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $42omo.useState)(false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(defaultIsOpen);
    const [value, setValue] = (0, $42omo.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $42omo.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$6a13142a7a4ddecd$var$analyticsAttributes
    });
    (0, $42omo.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $42omo.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $42omo.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $2oOe7.defaultTimeFormat));
            } catch  {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $dWCFT.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $5TGLQ.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $99qsA.default) : (0, $6T8v4.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $2oOe7.defaultTimeFormat));
        const date = (0, $6BP5H.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $cFEpk.default)(date)) return time;
        if (timeFormat) return (0, $dWCFT.default)(date, (0, $7lMCw.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $cda8t.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $2oOe7.EmptyComponent),
        Menu: (0, $jgNUL.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $2oOe7.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $eKXGE.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$6a13142a7a4ddecd$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $l998X.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                // @ts-ignore - Type mismatch with components - workaround for help-center local consumption
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: true,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                // @ts-ignore - Type mismatch with onChange handler - workaround for help-center local consumption
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $2oOe7.placeholderDatetime)),
                // @ts-ignore - Type mismatch with styles config - workaround for help-center local consumption
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                // @ts-ignore
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps
            })
        ]
    });
});
var $6a13142a7a4ddecd$export$2e2bcd8739ae039 = $6a13142a7a4ddecd$var$TimePicker;
module.exports["default"] = $6a13142a7a4ddecd$export$2e2bcd8739ae039;

});

parcelRegister("jgNUL", function(module, exports) {
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");


var $hq1yX = parcelRequire("hq1yX");

const $234f598d19f6cd6a$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hq1yX.default), {
        inputValue: selectProps.inputValue,
        //@ts-ignore react-select unsupported props
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });
module.exports["FixedLayerMenu"] = $234f598d19f6cd6a$export$982ad994195b4356;

});

parcelRegister("6BP5H", function(module, exports) {
$parcel$export(module.exports, "default", () => $8831c39f93c6811b$export$2e2bcd8739ae039);
const $8831c39f93c6811b$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $8831c39f93c6811b$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $8831c39f93c6811b$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $8831c39f93c6811b$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $8831c39f93c6811b$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $8831c39f93c6811b$var$map24[hour];
    return hour;
}
function $8831c39f93c6811b$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $8831c39f93c6811b$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $8831c39f93c6811b$var$formatSemi24(timeArray[0].trim());
    const hour = $8831c39f93c6811b$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $8831c39f93c6811b$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $8831c39f93c6811b$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $8831c39f93c6811b$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $8831c39f93c6811b$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$8831c39f93c6811b$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $8831c39f93c6811b$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $8831c39f93c6811b$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $8831c39f93c6811b$var$assignToDate(time2);
}

});

parcelRegister("6otn0", function(module, exports) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $4a7bc43a0955ef89$var$ch2 = {};
var $4a7bc43a0955ef89$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($4a7bc43a0955ef89$var$ch2[id] || ($4a7bc43a0955ef89$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $4a7bc43a0955ef89$var$u8 = Uint8Array, $4a7bc43a0955ef89$var$u16 = Uint16Array, $4a7bc43a0955ef89$var$i32 = Int32Array;
// fixed length extra bits
var $4a7bc43a0955ef89$var$fleb = new $4a7bc43a0955ef89$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $4a7bc43a0955ef89$var$fdeb = new $4a7bc43a0955ef89$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $4a7bc43a0955ef89$var$clim = new $4a7bc43a0955ef89$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $4a7bc43a0955ef89$var$freb = function(eb, start) {
    var b = new $4a7bc43a0955ef89$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $4a7bc43a0955ef89$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $4a7bc43a0955ef89$var$_a = $4a7bc43a0955ef89$var$freb($4a7bc43a0955ef89$var$fleb, 2), $4a7bc43a0955ef89$var$fl = $4a7bc43a0955ef89$var$_a.b, $4a7bc43a0955ef89$var$revfl = $4a7bc43a0955ef89$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$4a7bc43a0955ef89$var$fl[28] = 258, $4a7bc43a0955ef89$var$revfl[258] = 28;
var $4a7bc43a0955ef89$var$_b = $4a7bc43a0955ef89$var$freb($4a7bc43a0955ef89$var$fdeb, 0), $4a7bc43a0955ef89$var$fd = $4a7bc43a0955ef89$var$_b.b, $4a7bc43a0955ef89$var$revfd = $4a7bc43a0955ef89$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $4a7bc43a0955ef89$var$rev = new $4a7bc43a0955ef89$var$u16(32768);
for(var $4a7bc43a0955ef89$var$i = 0; $4a7bc43a0955ef89$var$i < 32768; ++$4a7bc43a0955ef89$var$i){
    // reverse table algorithm from SO
    var $4a7bc43a0955ef89$var$x = ($4a7bc43a0955ef89$var$i & 0xAAAA) >> 1 | ($4a7bc43a0955ef89$var$i & 0x5555) << 1;
    $4a7bc43a0955ef89$var$x = ($4a7bc43a0955ef89$var$x & 0xCCCC) >> 2 | ($4a7bc43a0955ef89$var$x & 0x3333) << 2;
    $4a7bc43a0955ef89$var$x = ($4a7bc43a0955ef89$var$x & 0xF0F0) >> 4 | ($4a7bc43a0955ef89$var$x & 0x0F0F) << 4;
    $4a7bc43a0955ef89$var$rev[$4a7bc43a0955ef89$var$i] = (($4a7bc43a0955ef89$var$x & 0xFF00) >> 8 | ($4a7bc43a0955ef89$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $4a7bc43a0955ef89$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $4a7bc43a0955ef89$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $4a7bc43a0955ef89$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $4a7bc43a0955ef89$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$4a7bc43a0955ef89$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $4a7bc43a0955ef89$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $4a7bc43a0955ef89$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $4a7bc43a0955ef89$var$flt = new $4a7bc43a0955ef89$var$u8(288);
for(var $4a7bc43a0955ef89$var$i = 0; $4a7bc43a0955ef89$var$i < 144; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 8;
for(var $4a7bc43a0955ef89$var$i = 144; $4a7bc43a0955ef89$var$i < 256; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 9;
for(var $4a7bc43a0955ef89$var$i = 256; $4a7bc43a0955ef89$var$i < 280; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 7;
for(var $4a7bc43a0955ef89$var$i = 280; $4a7bc43a0955ef89$var$i < 288; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 8;
// fixed distance tree
var $4a7bc43a0955ef89$var$fdt = new $4a7bc43a0955ef89$var$u8(32);
for(var $4a7bc43a0955ef89$var$i = 0; $4a7bc43a0955ef89$var$i < 32; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$fdt[$4a7bc43a0955ef89$var$i] = 5;
// fixed length map
var $4a7bc43a0955ef89$var$flm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$flt, 9, 0), $4a7bc43a0955ef89$var$flrm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$flt, 9, 1);
// fixed distance map
var $4a7bc43a0955ef89$var$fdm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$fdt, 5, 0), $4a7bc43a0955ef89$var$fdrm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$fdt, 5, 1);
// find max of array
var $4a7bc43a0955ef89$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $4a7bc43a0955ef89$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $4a7bc43a0955ef89$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $4a7bc43a0955ef89$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $4a7bc43a0955ef89$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $4a7bc43a0955ef89$var$u8(v.subarray(s, e));
};
var $4a7bc43a0955ef89$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $4a7bc43a0955ef89$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $4a7bc43a0955ef89$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $4a7bc43a0955ef89$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $4a7bc43a0955ef89$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $4a7bc43a0955ef89$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $4a7bc43a0955ef89$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $4a7bc43a0955ef89$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $4a7bc43a0955ef89$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $4a7bc43a0955ef89$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $4a7bc43a0955ef89$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $4a7bc43a0955ef89$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $4a7bc43a0955ef89$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $4a7bc43a0955ef89$var$flrm, dm = $4a7bc43a0955ef89$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $4a7bc43a0955ef89$var$bits(dat, pos, 31) + 257, hcLen = $4a7bc43a0955ef89$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $4a7bc43a0955ef89$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $4a7bc43a0955ef89$var$u8(tl);
                // code length tree
                var clt = new $4a7bc43a0955ef89$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$4a7bc43a0955ef89$var$clim[i]] = $4a7bc43a0955ef89$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $4a7bc43a0955ef89$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $4a7bc43a0955ef89$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$4a7bc43a0955ef89$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $4a7bc43a0955ef89$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $4a7bc43a0955ef89$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $4a7bc43a0955ef89$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $4a7bc43a0955ef89$var$max(lt);
                // max dist bits
                dbt = $4a7bc43a0955ef89$var$max(dt);
                lm = $4a7bc43a0955ef89$var$hMap(lt, lbt, 1);
                dm = $4a7bc43a0955ef89$var$hMap(dt, dbt, 1);
            } else $4a7bc43a0955ef89$var$err(1);
            if (pos > tbts) {
                if (noSt) $4a7bc43a0955ef89$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$4a7bc43a0955ef89$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $4a7bc43a0955ef89$var$err(0);
                break;
            }
            if (!c) $4a7bc43a0955ef89$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $4a7bc43a0955ef89$var$fleb[i];
                    add = $4a7bc43a0955ef89$var$bits(dat, pos, (1 << b) - 1) + $4a7bc43a0955ef89$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$4a7bc43a0955ef89$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $4a7bc43a0955ef89$var$err(3);
                pos += d & 15;
                var dt = $4a7bc43a0955ef89$var$fd[dsym];
                if (dsym > 3) {
                    var b = $4a7bc43a0955ef89$var$fdeb[dsym];
                    dt += $4a7bc43a0955ef89$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $4a7bc43a0955ef89$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $4a7bc43a0955ef89$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $4a7bc43a0955ef89$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $4a7bc43a0955ef89$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $4a7bc43a0955ef89$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $4a7bc43a0955ef89$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $4a7bc43a0955ef89$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $4a7bc43a0955ef89$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $4a7bc43a0955ef89$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $4a7bc43a0955ef89$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $4a7bc43a0955ef89$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $4a7bc43a0955ef89$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($4a7bc43a0955ef89$var$ln(n.l, l, d + 1), $4a7bc43a0955ef89$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $4a7bc43a0955ef89$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $4a7bc43a0955ef89$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $4a7bc43a0955ef89$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $4a7bc43a0955ef89$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $4a7bc43a0955ef89$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $4a7bc43a0955ef89$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $4a7bc43a0955ef89$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $4a7bc43a0955ef89$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $4a7bc43a0955ef89$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $4a7bc43a0955ef89$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $4a7bc43a0955ef89$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $4a7bc43a0955ef89$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $4a7bc43a0955ef89$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$4a7bc43a0955ef89$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $4a7bc43a0955ef89$var$clen(lf, $4a7bc43a0955ef89$var$flt) + $4a7bc43a0955ef89$var$clen(df, $4a7bc43a0955ef89$var$fdt) + eb;
    var dtlen = $4a7bc43a0955ef89$var$clen(lf, dlt) + $4a7bc43a0955ef89$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $4a7bc43a0955ef89$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $4a7bc43a0955ef89$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $4a7bc43a0955ef89$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $4a7bc43a0955ef89$var$hMap(dlt, mlb, 0), ll = dlt, dm = $4a7bc43a0955ef89$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $4a7bc43a0955ef89$var$hMap(lct, mlcb, 0);
        $4a7bc43a0955ef89$var$wbits(out, p, nlc - 257);
        $4a7bc43a0955ef89$var$wbits(out, p + 5, ndc - 1);
        $4a7bc43a0955ef89$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$4a7bc43a0955ef89$var$wbits(out, p + 3 * i, lct[$4a7bc43a0955ef89$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $4a7bc43a0955ef89$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $4a7bc43a0955ef89$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $4a7bc43a0955ef89$var$flm, ll = $4a7bc43a0955ef89$var$flt, dm = $4a7bc43a0955ef89$var$fdm, dl = $4a7bc43a0955ef89$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $4a7bc43a0955ef89$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $4a7bc43a0955ef89$var$wbits(out, p, sym >> 23 & 31), p += $4a7bc43a0955ef89$var$fleb[len];
            var dst = sym & 31;
            $4a7bc43a0955ef89$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $4a7bc43a0955ef89$var$wbits16(out, p, sym >> 5 & 8191), p += $4a7bc43a0955ef89$var$fdeb[dst];
        } else $4a7bc43a0955ef89$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $4a7bc43a0955ef89$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $4a7bc43a0955ef89$var$deo = /*#__PURE__*/ new $4a7bc43a0955ef89$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $4a7bc43a0955ef89$var$et = /*#__PURE__*/ new $4a7bc43a0955ef89$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $4a7bc43a0955ef89$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $4a7bc43a0955ef89$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $4a7bc43a0955ef89$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $4a7bc43a0955ef89$var$u16(32768), head = st.h || new $4a7bc43a0955ef89$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $4a7bc43a0955ef89$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $4a7bc43a0955ef89$var$u16(288), df = new $4a7bc43a0955ef89$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $4a7bc43a0955ef89$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $4a7bc43a0955ef89$var$revfl[l] << 18 | $4a7bc43a0955ef89$var$revfd[d];
                    var lin = $4a7bc43a0955ef89$var$revfl[l] & 31, din = $4a7bc43a0955ef89$var$revfd[d] & 31;
                    eb += $4a7bc43a0955ef89$var$fleb[lin] + $4a7bc43a0955ef89$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $4a7bc43a0955ef89$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $4a7bc43a0955ef89$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $4a7bc43a0955ef89$var$slc(o, 0, pre + $4a7bc43a0955ef89$var$shft(pos) + post);
};
// CRC32 table
var $4a7bc43a0955ef89$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $4a7bc43a0955ef89$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $4a7bc43a0955ef89$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $4a7bc43a0955ef89$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $4a7bc43a0955ef89$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $4a7bc43a0955ef89$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $4a7bc43a0955ef89$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $4a7bc43a0955ef89$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $4a7bc43a0955ef89$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $4a7bc43a0955ef89$var$ch = [];
// clone bufs
var $4a7bc43a0955ef89$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $4a7bc43a0955ef89$var$wrkr = function(fns, init, id, cb) {
    if (!$4a7bc43a0955ef89$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $4a7bc43a0955ef89$var$wcln(fns[i], fnStr, td_1);
        $4a7bc43a0955ef89$var$ch[id] = {
            c: $4a7bc43a0955ef89$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $4a7bc43a0955ef89$var$mrg({}, $4a7bc43a0955ef89$var$ch[id].e);
    return $4a7bc43a0955ef89$var$wk($4a7bc43a0955ef89$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $4a7bc43a0955ef89$var$cbfs(td), cb);
};
// base async inflate fn
var $4a7bc43a0955ef89$var$bInflt = function() {
    return [
        $4a7bc43a0955ef89$var$u8,
        $4a7bc43a0955ef89$var$u16,
        $4a7bc43a0955ef89$var$i32,
        $4a7bc43a0955ef89$var$fleb,
        $4a7bc43a0955ef89$var$fdeb,
        $4a7bc43a0955ef89$var$clim,
        $4a7bc43a0955ef89$var$fl,
        $4a7bc43a0955ef89$var$fd,
        $4a7bc43a0955ef89$var$flrm,
        $4a7bc43a0955ef89$var$fdrm,
        $4a7bc43a0955ef89$var$rev,
        $4a7bc43a0955ef89$var$ec,
        $4a7bc43a0955ef89$var$hMap,
        $4a7bc43a0955ef89$var$max,
        $4a7bc43a0955ef89$var$bits,
        $4a7bc43a0955ef89$var$bits16,
        $4a7bc43a0955ef89$var$shft,
        $4a7bc43a0955ef89$var$slc,
        $4a7bc43a0955ef89$var$err,
        $4a7bc43a0955ef89$var$inflt,
        $4a7bc43a0955ef89$export$90366d8b308ba94a,
        $4a7bc43a0955ef89$var$pbf,
        $4a7bc43a0955ef89$var$gopt
    ];
};
var $4a7bc43a0955ef89$var$bDflt = function() {
    return [
        $4a7bc43a0955ef89$var$u8,
        $4a7bc43a0955ef89$var$u16,
        $4a7bc43a0955ef89$var$i32,
        $4a7bc43a0955ef89$var$fleb,
        $4a7bc43a0955ef89$var$fdeb,
        $4a7bc43a0955ef89$var$clim,
        $4a7bc43a0955ef89$var$revfl,
        $4a7bc43a0955ef89$var$revfd,
        $4a7bc43a0955ef89$var$flm,
        $4a7bc43a0955ef89$var$flt,
        $4a7bc43a0955ef89$var$fdm,
        $4a7bc43a0955ef89$var$fdt,
        $4a7bc43a0955ef89$var$rev,
        $4a7bc43a0955ef89$var$deo,
        $4a7bc43a0955ef89$var$et,
        $4a7bc43a0955ef89$var$hMap,
        $4a7bc43a0955ef89$var$wbits,
        $4a7bc43a0955ef89$var$wbits16,
        $4a7bc43a0955ef89$var$hTree,
        $4a7bc43a0955ef89$var$ln,
        $4a7bc43a0955ef89$var$lc,
        $4a7bc43a0955ef89$var$clen,
        $4a7bc43a0955ef89$var$wfblk,
        $4a7bc43a0955ef89$var$wblk,
        $4a7bc43a0955ef89$var$shft,
        $4a7bc43a0955ef89$var$slc,
        $4a7bc43a0955ef89$var$dflt,
        $4a7bc43a0955ef89$var$dopt,
        $4a7bc43a0955ef89$export$21533ff51b8a0b4a,
        $4a7bc43a0955ef89$var$pbf
    ];
};
// gzip extra
var $4a7bc43a0955ef89$var$gze = function() {
    return [
        $4a7bc43a0955ef89$var$gzh,
        $4a7bc43a0955ef89$var$gzhl,
        $4a7bc43a0955ef89$var$wbytes,
        $4a7bc43a0955ef89$var$crc,
        $4a7bc43a0955ef89$var$crct
    ];
};
// gunzip extra
var $4a7bc43a0955ef89$var$guze = function() {
    return [
        $4a7bc43a0955ef89$var$gzs,
        $4a7bc43a0955ef89$var$gzl
    ];
};
// zlib extra
var $4a7bc43a0955ef89$var$zle = function() {
    return [
        $4a7bc43a0955ef89$var$zlh,
        $4a7bc43a0955ef89$var$wbytes,
        $4a7bc43a0955ef89$var$adler
    ];
};
// unzlib extra
var $4a7bc43a0955ef89$var$zule = function() {
    return [
        $4a7bc43a0955ef89$var$zls
    ];
};
// post buf
var $4a7bc43a0955ef89$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $4a7bc43a0955ef89$var$gopt = function(o) {
    return o && {
        out: o.size && new $4a7bc43a0955ef89$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $4a7bc43a0955ef89$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $4a7bc43a0955ef89$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $4a7bc43a0955ef89$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var $4a7bc43a0955ef89$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $4a7bc43a0955ef89$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $4a7bc43a0955ef89$var$err(5);
        if (t) strm.ondata($4a7bc43a0955ef89$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var $4a7bc43a0955ef89$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $4a7bc43a0955ef89$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $4a7bc43a0955ef89$var$b8 = function(d, b) {
    return $4a7bc43a0955ef89$var$b4(d, b) + $4a7bc43a0955ef89$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $4a7bc43a0955ef89$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $4a7bc43a0955ef89$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $4a7bc43a0955ef89$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $4a7bc43a0955ef89$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $4a7bc43a0955ef89$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $4a7bc43a0955ef89$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $4a7bc43a0955ef89$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $4a7bc43a0955ef89$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $4a7bc43a0955ef89$var$adler();
        h.p(o.dictionary);
        $4a7bc43a0955ef89$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $4a7bc43a0955ef89$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $4a7bc43a0955ef89$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $4a7bc43a0955ef89$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $4a7bc43a0955ef89$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $4a7bc43a0955ef89$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $4a7bc43a0955ef89$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($4a7bc43a0955ef89$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.s.l) $4a7bc43a0955ef89$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $4a7bc43a0955ef89$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.s.l) $4a7bc43a0955ef89$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $4a7bc43a0955ef89$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bDflt,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$ae157b6234afe138
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$ae157b6234afe138(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $4a7bc43a0955ef89$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bDflt
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $4a7bc43a0955ef89$export$21533ff51b8a0b4a(data, opts) {
    return $4a7bc43a0955ef89$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $4a7bc43a0955ef89$var$u8(32768);
        this.p = new $4a7bc43a0955ef89$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.d) $4a7bc43a0955ef89$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $4a7bc43a0955ef89$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $4a7bc43a0955ef89$var$inflt(this.p, this.s, this.o);
        this.ondata($4a7bc43a0955ef89$var$slc(dt, bts, this.s.b), this.d);
        this.o = $4a7bc43a0955ef89$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $4a7bc43a0955ef89$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bInflt,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$d1de70a877d6e43c
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$d1de70a877d6e43c(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $4a7bc43a0955ef89$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bInflt
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$90366d8b308ba94a(ev.data[0], $4a7bc43a0955ef89$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $4a7bc43a0955ef89$export$90366d8b308ba94a(data, opts) {
    return $4a7bc43a0955ef89$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $4a7bc43a0955ef89$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $4a7bc43a0955ef89$var$crc();
        this.l = 0;
        this.v = 1;
        $4a7bc43a0955ef89$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $4a7bc43a0955ef89$var$dopt(c, this.o, this.v && $4a7bc43a0955ef89$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $4a7bc43a0955ef89$var$gzh(raw, this.o), this.v = 0;
        if (f) $4a7bc43a0955ef89$var$wbytes(raw, raw.length - 8, this.c.d()), $4a7bc43a0955ef89$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $4a7bc43a0955ef89$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bDflt,
            $4a7bc43a0955ef89$var$gze,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$ae157b6234afe138,
                    $4a7bc43a0955ef89$export$8e4b66d280bf8342
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$8e4b66d280bf8342(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $4a7bc43a0955ef89$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bDflt,
        $4a7bc43a0955ef89$var$gze,
        function() {
            return [
                $4a7bc43a0955ef89$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $4a7bc43a0955ef89$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $4a7bc43a0955ef89$var$crc(), l = data.length;
    c.p(data);
    var d = $4a7bc43a0955ef89$var$dopt(data, opts, $4a7bc43a0955ef89$var$gzhl(opts), 8), s = d.length;
    return $4a7bc43a0955ef89$var$gzh(d, opts), $4a7bc43a0955ef89$var$wbytes(d, s - 8, c.d()), $4a7bc43a0955ef89$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $4a7bc43a0955ef89$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $4a7bc43a0955ef89$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = $4a7bc43a0955ef89$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $4a7bc43a0955ef89$var$u8(0);
            this.push(new $4a7bc43a0955ef89$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $4a7bc43a0955ef89$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bInflt,
            $4a7bc43a0955ef89$var$guze,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$d1de70a877d6e43c,
                    $4a7bc43a0955ef89$export$4cb607de6db70415
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $4a7bc43a0955ef89$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bInflt,
        $4a7bc43a0955ef89$var$guze,
        function() {
            return [
                $4a7bc43a0955ef89$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $4a7bc43a0955ef89$export$c80456f7aaba691c(data, opts) {
    var st = $4a7bc43a0955ef89$var$gzs(data);
    if (st + 8 > data.length) $4a7bc43a0955ef89$var$err(6, 'invalid gzip data');
    return $4a7bc43a0955ef89$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $4a7bc43a0955ef89$var$u8($4a7bc43a0955ef89$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $4a7bc43a0955ef89$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $4a7bc43a0955ef89$var$adler();
        this.v = 1;
        $4a7bc43a0955ef89$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $4a7bc43a0955ef89$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $4a7bc43a0955ef89$var$zlh(raw, this.o), this.v = 0;
        if (f) $4a7bc43a0955ef89$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $4a7bc43a0955ef89$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bDflt,
            $4a7bc43a0955ef89$var$zle,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$ae157b6234afe138,
                    $4a7bc43a0955ef89$export$4187ccf2467013b9
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$4187ccf2467013b9(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $4a7bc43a0955ef89$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bDflt,
        $4a7bc43a0955ef89$var$zle,
        function() {
            return [
                $4a7bc43a0955ef89$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $4a7bc43a0955ef89$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $4a7bc43a0955ef89$var$adler();
    a.p(data);
    var d = $4a7bc43a0955ef89$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $4a7bc43a0955ef89$var$zlh(d, opts), $4a7bc43a0955ef89$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $4a7bc43a0955ef89$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($4a7bc43a0955ef89$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $4a7bc43a0955ef89$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $4a7bc43a0955ef89$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bInflt,
            $4a7bc43a0955ef89$var$zule,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$d1de70a877d6e43c,
                    $4a7bc43a0955ef89$export$af2424f875ff1b17
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$af2424f875ff1b17(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $4a7bc43a0955ef89$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bInflt,
        $4a7bc43a0955ef89$var$zule,
        function() {
            return [
                $4a7bc43a0955ef89$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$9ec8134f0f1b9fc6(ev.data[0], $4a7bc43a0955ef89$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $4a7bc43a0955ef89$export$9ec8134f0f1b9fc6(data, opts) {
    return $4a7bc43a0955ef89$var$inflt(data.subarray($4a7bc43a0955ef89$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $4a7bc43a0955ef89$export$4cb607de6db70415;
        this.I = $4a7bc43a0955ef89$export$d1de70a877d6e43c;
        this.Z = $4a7bc43a0955ef89$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $4a7bc43a0955ef89$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $4a7bc43a0955ef89$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $4a7bc43a0955ef89$export$d5adcdd968132151;
        this.I = $4a7bc43a0955ef89$export$fff8358d6dbaa9cc;
        this.Z = $4a7bc43a0955ef89$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $4a7bc43a0955ef89$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $4a7bc43a0955ef89$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $4a7bc43a0955ef89$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $4a7bc43a0955ef89$export$cae1ce83fe4a1782(data, opts, cb) : $4a7bc43a0955ef89$export$ca7cbb494e731274(data, opts, cb);
}
function $4a7bc43a0955ef89$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $4a7bc43a0955ef89$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $4a7bc43a0955ef89$export$90366d8b308ba94a(data, opts) : $4a7bc43a0955ef89$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $4a7bc43a0955ef89$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $4a7bc43a0955ef89$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $4a7bc43a0955ef89$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $4a7bc43a0955ef89$var$u8(0),
                op
            ];
            $4a7bc43a0955ef89$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $4a7bc43a0955ef89$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $4a7bc43a0955ef89$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $4a7bc43a0955ef89$var$tds = 0;
try {
    $4a7bc43a0955ef89$var$td.decode($4a7bc43a0955ef89$var$et, {
        stream: true
    });
    $4a7bc43a0955ef89$var$tds = 1;
} catch (e) {}
// decode UTF8
var $4a7bc43a0955ef89$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $4a7bc43a0955ef89$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $4a7bc43a0955ef89$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($4a7bc43a0955ef89$var$tds) this.t = new TextDecoder();
        else this.p = $4a7bc43a0955ef89$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $4a7bc43a0955ef89$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $4a7bc43a0955ef89$var$err(4);
        var dat = new $4a7bc43a0955ef89$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $4a7bc43a0955ef89$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $4a7bc43a0955ef89$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $4a7bc43a0955ef89$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.d) $4a7bc43a0955ef89$var$err(4);
        this.ondata($4a7bc43a0955ef89$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $4a7bc43a0955ef89$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $4a7bc43a0955ef89$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($4a7bc43a0955ef89$var$te) return $4a7bc43a0955ef89$var$te.encode(str);
    var l = str.length;
    var ar = new $4a7bc43a0955ef89$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $4a7bc43a0955ef89$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $4a7bc43a0955ef89$var$slc(ar, 0, ai);
}
function $4a7bc43a0955ef89$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($4a7bc43a0955ef89$var$td) return $4a7bc43a0955ef89$var$td.decode(dat);
    else {
        var _a = $4a7bc43a0955ef89$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $4a7bc43a0955ef89$var$err(8);
        return s;
    }
}
// deflate bit flag
var $4a7bc43a0955ef89$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $4a7bc43a0955ef89$var$slzh = function(d, b) {
    return b + 30 + $4a7bc43a0955ef89$var$b2(d, b + 26) + $4a7bc43a0955ef89$var$b2(d, b + 28);
};
// read zip header
var $4a7bc43a0955ef89$var$zh = function(d, b, z) {
    var fnl = $4a7bc43a0955ef89$var$b2(d, b + 28), fn = $4a7bc43a0955ef89$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($4a7bc43a0955ef89$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $4a7bc43a0955ef89$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $4a7bc43a0955ef89$var$z64e(d, es) : [
        bs,
        $4a7bc43a0955ef89$var$b4(d, b + 24),
        $4a7bc43a0955ef89$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $4a7bc43a0955ef89$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $4a7bc43a0955ef89$var$b2(d, b + 30) + $4a7bc43a0955ef89$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $4a7bc43a0955ef89$var$z64e = function(d, b) {
    for(; $4a7bc43a0955ef89$var$b2(d, b) != 1; b += 4 + $4a7bc43a0955ef89$var$b2(d, b + 2));
    return [
        $4a7bc43a0955ef89$var$b8(d, b + 12),
        $4a7bc43a0955ef89$var$b8(d, b + 4),
        $4a7bc43a0955ef89$var$b8(d, b + 20)
    ];
};
// extra field length
var $4a7bc43a0955ef89$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $4a7bc43a0955ef89$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $4a7bc43a0955ef89$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $4a7bc43a0955ef89$var$exfl(ex);
    $4a7bc43a0955ef89$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $4a7bc43a0955ef89$var$err(10);
    $4a7bc43a0955ef89$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $4a7bc43a0955ef89$var$wbytes(d, b, f.crc);
        $4a7bc43a0955ef89$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $4a7bc43a0955ef89$var$wbytes(d, b + 8, f.size);
    }
    $4a7bc43a0955ef89$var$wbytes(d, b + 12, fl);
    $4a7bc43a0955ef89$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $4a7bc43a0955ef89$var$wbytes(d, b, col);
        $4a7bc43a0955ef89$var$wbytes(d, b + 6, f.attrs);
        $4a7bc43a0955ef89$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $4a7bc43a0955ef89$var$wbytes(d, b, +k);
        $4a7bc43a0955ef89$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $4a7bc43a0955ef89$var$wzf = function(o, b, c, d, e) {
    $4a7bc43a0955ef89$var$wbytes(o, b, 0x6054B50); // skip disk
    $4a7bc43a0955ef89$var$wbytes(o, b + 8, c);
    $4a7bc43a0955ef89$var$wbytes(o, b + 10, c);
    $4a7bc43a0955ef89$var$wbytes(o, b + 12, d);
    $4a7bc43a0955ef89$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $4a7bc43a0955ef89$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $4a7bc43a0955ef89$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $4a7bc43a0955ef89$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $4a7bc43a0955ef89$export$2b25194e1767ea06.call(this, filename);
        this.d = new $4a7bc43a0955ef89$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $4a7bc43a0955ef89$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $4a7bc43a0955ef89$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $4a7bc43a0955ef89$export$2b25194e1767ea06.call(this, filename);
        this.d = new $4a7bc43a0955ef89$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $4a7bc43a0955ef89$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $4a7bc43a0955ef89$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($4a7bc43a0955ef89$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $4a7bc43a0955ef89$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $4a7bc43a0955ef89$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $4a7bc43a0955ef89$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($4a7bc43a0955ef89$var$err(11, 0, 1), null, false);
            var header = new $4a7bc43a0955ef89$var$u8(hl_1);
            $4a7bc43a0955ef89$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $4a7bc43a0955ef89$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $4a7bc43a0955ef89$var$u8(16);
                        $4a7bc43a0955ef89$var$wbytes(dd, 0, 0x8074B50);
                        $4a7bc43a0955ef89$var$wbytes(dd, 4, file.crc);
                        $4a7bc43a0955ef89$var$wbytes(dd, 8, cl_1);
                        $4a7bc43a0955ef89$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($4a7bc43a0955ef89$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $4a7bc43a0955ef89$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $4a7bc43a0955ef89$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $4a7bc43a0955ef89$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $4a7bc43a0955ef89$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    var r = {};
    $4a7bc43a0955ef89$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $4a7bc43a0955ef89$var$mt(function() {
            cb(a, b);
        });
    };
    $4a7bc43a0955ef89$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $4a7bc43a0955ef89$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $4a7bc43a0955ef89$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $4a7bc43a0955ef89$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $4a7bc43a0955ef89$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $4a7bc43a0955ef89$var$crc(), size = file.length;
        c.p(file);
        var f = $4a7bc43a0955ef89$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $4a7bc43a0955ef89$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $4a7bc43a0955ef89$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $4a7bc43a0955ef89$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($4a7bc43a0955ef89$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $4a7bc43a0955ef89$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($4a7bc43a0955ef89$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $4a7bc43a0955ef89$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $4a7bc43a0955ef89$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $4a7bc43a0955ef89$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $4a7bc43a0955ef89$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $4a7bc43a0955ef89$var$exfl(p.extra);
        if (s > 65535) $4a7bc43a0955ef89$var$err(11);
        var d = compression ? $4a7bc43a0955ef89$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $4a7bc43a0955ef89$var$crc();
        c.p(file);
        files.push($4a7bc43a0955ef89$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $4a7bc43a0955ef89$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $4a7bc43a0955ef89$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $4a7bc43a0955ef89$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $4a7bc43a0955ef89$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $4a7bc43a0955ef89$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $4a7bc43a0955ef89$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $4a7bc43a0955ef89$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $4a7bc43a0955ef89$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $4a7bc43a0955ef89$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $4a7bc43a0955ef89$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $4a7bc43a0955ef89$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $4a7bc43a0955ef89$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $4a7bc43a0955ef89$export$93f81d5bbbb7c6bf
        };
        this.p = $4a7bc43a0955ef89$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $4a7bc43a0955ef89$var$err(5);
        if (!this.p) $4a7bc43a0955ef89$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $4a7bc43a0955ef89$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $4a7bc43a0955ef89$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $4a7bc43a0955ef89$var$b2(buf, i + 6), cmp_1 = $4a7bc43a0955ef89$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $4a7bc43a0955ef89$var$b2(buf, i + 26), es = $4a7bc43a0955ef89$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $4a7bc43a0955ef89$var$b4(buf, i + 18), su_1 = $4a7bc43a0955ef89$var$b4(buf, i + 22);
                        var fn_1 = $4a7bc43a0955ef89$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $4a7bc43a0955ef89$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $4a7bc43a0955ef89$var$err(5);
                                if (!sc_1) file_1.ondata(null, $4a7bc43a0955ef89$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($4a7bc43a0955ef89$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($4a7bc43a0955ef89$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $4a7bc43a0955ef89$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($4a7bc43a0955ef89$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $4a7bc43a0955ef89$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $4a7bc43a0955ef89$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $4a7bc43a0955ef89$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $4a7bc43a0955ef89$var$mt(function() {
            cb(a, b);
        });
    };
    $4a7bc43a0955ef89$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $4a7bc43a0955ef89$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($4a7bc43a0955ef89$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $4a7bc43a0955ef89$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $4a7bc43a0955ef89$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $4a7bc43a0955ef89$var$b4(data, e - 12);
            z = $4a7bc43a0955ef89$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $4a7bc43a0955ef89$var$b4(data, ze + 32);
                o = $4a7bc43a0955ef89$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $4a7bc43a0955ef89$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $4a7bc43a0955ef89$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $4a7bc43a0955ef89$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $4a7bc43a0955ef89$export$90366d8b308ba94a(infl, {
                            out: new $4a7bc43a0955ef89$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($4a7bc43a0955ef89$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($4a7bc43a0955ef89$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $4a7bc43a0955ef89$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $4a7bc43a0955ef89$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $4a7bc43a0955ef89$var$err(13);
    var c = $4a7bc43a0955ef89$var$b2(data, e + 8);
    if (!c) return {};
    var o = $4a7bc43a0955ef89$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $4a7bc43a0955ef89$var$b4(data, e - 12);
        z = $4a7bc43a0955ef89$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $4a7bc43a0955ef89$var$b4(data, ze + 32);
            o = $4a7bc43a0955ef89$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $4a7bc43a0955ef89$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $4a7bc43a0955ef89$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $4a7bc43a0955ef89$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $4a7bc43a0955ef89$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $4a7bc43a0955ef89$var$u8(su)
            });
            else $4a7bc43a0955ef89$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}
module.exports["gzipSync"] = $4a7bc43a0955ef89$export$3d616c3fb3e15483;
module.exports["gunzipSync"] = $4a7bc43a0955ef89$export$c80456f7aaba691c;

});


$parcel$global.rlb("iKEjB")
//# sourceMappingURL=GoalPanel.460d4f00.js.map
